export default function(data, el) {
  var self = this;

  self.$el = $(el);
  self.items = ko.observableArray([]);
  self.showItemCards = ko.observable(false);

  self.initCarousel = function(){
    var carouselConfig = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      autoplaySpeed: 9000,
      accessibility: false,
      pauseOnFocus: true,
      pauseOnDotsHover: true,
      arrows: false,

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    var $carousel = $('.js-carousel');

    $carousel.on('init', function(slick){
      $carousel.removeClass('is-invisible');
      // improve tabability for accessiblity/wcag

      $carousel.find('.slick-slide').find('a, btn')
        .attr('tabindex', '-1');

      $carousel.find('.slick-slide.slick-active').find('a, btn')
        .attr('tabindex', '');

      $carousel.find('.slick-list')
        .attr('aria-live', 'off');

      $carousel.find('.slick-dots button')
        .prepend('carousel page');

      $carousel.find('.slick-dots li')
        .attr('aria-hidden', 'false');
    });

    $carousel.on('afterChange', function(event, slick, currentSlide){
      // improve tabability for accessiblity/wcag

      $carousel.find('.slick-slide').find('a, btn')
        .attr('tabindex', '-1');

      $carousel.find('.slick-slide.slick-active').find('a, btn')
        .attr('tabindex', '');

      $carousel.find('.slick-dots li')
        .attr('aria-hidden', 'false');
    });

    $carousel.slick(carouselConfig);

    // not sure why I need this, but this forces the slider to pause on focus
    $('body').on('focus.slickslider', '.js-carousel', function(){
      $carousel.slick('slickPause');
      console.log('$carousel : pause');
    }).on('blur.slickslider', '.js-carousel', function(){
      $carousel.slick('slickPlay');
      console.log('$carousel : play');
    });
  };

  self.bindData = function (data) {
    var mapped = ko.mapping.fromJS(data);
    const listingKey = self.$el.data().listingKey || 'carouselItems';

    self.items(mapped[listingKey]());

    setTimeout(self.initCarousel, 500);
  };

  const __construct = function (that) {
    console.log('constructor called for CarouselListingViewModel');
    that.bindData(data);
    setTimeout(Kadenze.UIUtil.initDotDotDotTruncation, 500);
  }(this);
}